import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaGlobe,
  FaLayerGroup,
  FaDraftingCompass,
  FaCheckCircle,
  FaChartLine,
  FaCog,
  FaIndustry
} from 'react-icons/fa';

import {
  GiSpinningBlades,
  GiSewingNeedle
} from 'react-icons/gi';

// ============================================================
// IMAGE IMPORTS
// ============================================================

import logo from '../logos/Ashraftextile/asraf_textile.png';

import organza from '../logos/Ashraftextile/Silkcloth1.jpg';
import rawSilk from '../logos/Ashraftextile/Silkcloth2.jpg';

import waterjetLoom from '../logos/Ashraftextile/Machinecloth1.jpg';
import rapierLoom from '../logos/Ashraftextile/clothmachine2.jpg';

import threadWhite from '../logos/Ashraftextile/cloth_trading.png';


// ============================================================
// COMPONENT
// ============================================================

export default function AshrafTextile() {

  const navigate = useNavigate();

  return (
    <div style={styles.pageBackground}>

      {/* ======================================================
          MAIN PAGE
      ====================================================== */}

      <main
        className="ashraf-poster"
        style={styles.posterCard}
      >

        {/* ====================================================
            BACK BUTTON
        ==================================================== */}

        <div
          className="ashraf-back-wrapper"
          style={styles.backWrapper}
        >

          <button
            type="button"
            className="ashraf-back-button"
            style={styles.backButton}
            onClick={() => navigate('/')}
          >

            <FaArrowLeft style={styles.backIcon} />

            Back to All Sectors

          </button>

        </div>


        {/* ====================================================
            HEADER
        ==================================================== */}

        <header
          className="ashraf-header"
          style={styles.header}
        >

          {/* LEFT LOGO */}

          <div
            className="ashraf-header-left"
            style={styles.headerLeft}
          >

            <div className="logo-glow">

              <img
                src={logo}
                alt="Ashraf Textile"
                style={styles.logoImage}
              />

            </div>

            <div
              className="ashraf-header-logo-text"
              style={styles.headerLogoText}
            >

              <strong>
                ASHRAF TEXTILE
              </strong>

              <span>
                — SINCE 1901 —
              </span>

            </div>

          </div>


          {/* GOLD DIVIDER */}

          <div
            className="ashraf-header-divider"
            style={styles.headerDivider}
          />


          {/* TITLE */}

          <div
            className="ashraf-header-right"
            style={styles.headerRight}
          >

            <div className="title-eyebrow">
              ASHRAF GROUP OF INDUSTRIES
            </div>

            <h1
              className="ashraf-main-title"
              style={styles.mainTitle}
            >
              ASHRAF TEXTILE
            </h1>

            <p style={styles.mainSub}>
              — LEGACY SINCE 1901 —
            </p>

            <p
              className="ashraf-tagline"
              style={styles.tagline}
            >
              Where tradition meets modern weaving excellence.
            </p>

            <div style={styles.goldOrnament}>
              ❖
            </div>

          </div>

        </header>


        {/* ====================================================
            GALLERY
        ==================================================== */}

        <section
          className="ashraf-gallery"
          style={styles.galleryGrid}
        >

          {/* ORGANZA */}

          <div
            className="ashraf-gallery-card reveal-card"
            style={styles.galleryCard}
          >

            <div
              className="ashraf-image-area"
              style={styles.imageArea}
            >

              <img
                src={organza}
                alt="Premium Organza Fabrics"
                className="ashraf-gallery-image"
                style={styles.galleryImg}
              />

              <div className="image-overlay" />

            </div>

            <div
              className="ashraf-gallery-label"
              style={styles.galleryLabel}
            >

              <div style={styles.iconCircleSmall}>
                <GiSewingNeedle />
              </div>

              <span>
                PREMIUM ORGANZA
                <br />
                FABRICS
              </span>

            </div>

          </div>


          {/* RAW SILK */}

          <div
            className="ashraf-gallery-card reveal-card"
            style={styles.galleryCard}
          >

            <div
              className="ashraf-image-area"
              style={styles.imageArea}
            >

              <img
                src={rawSilk}
                alt="Korean Raw Silk"
                className="ashraf-gallery-image"
                style={styles.galleryImg}
              />

              <div className="image-overlay" />

            </div>

            <div
              className="ashraf-gallery-label"
              style={styles.galleryLabel}
            >

              <div style={styles.iconCircleSmall}>
                <FaLayerGroup />
              </div>

              <span>
                KOREAN RAW SILK
                <br />
                (VISCOSE)
              </span>

            </div>

          </div>


          {/* WATERJET */}

          <div
            className="ashraf-gallery-card reveal-card"
            style={styles.galleryCard}
          >

            <div
              className="ashraf-image-area"
              style={styles.imageArea}
            >

              <img
                src={waterjetLoom}
                alt="Waterjet Looms"
                className="ashraf-gallery-image"
                style={styles.galleryImg}
              />

              <div className="image-overlay" />

            </div>

            <div
              className="ashraf-gallery-label"
              style={styles.galleryLabel}
            >

              <div style={styles.iconCircleSmall}>
                <FaCog />
              </div>

              <span>
                WATERJET LOOMS
              </span>

            </div>

          </div>


          {/* RAPIER */}

          <div
            className="ashraf-gallery-card reveal-card"
            style={styles.galleryCard}
          >

            <div
              className="ashraf-image-area"
              style={styles.imageArea}
            >

              <img
                src={rapierLoom}
                alt="Rapier Looms"
                className="ashraf-gallery-image"
                style={styles.galleryImg}
              />

              <div className="image-overlay" />

            </div>

            <div
              className="ashraf-gallery-label"
              style={styles.galleryLabel}
            >

              <div style={styles.iconCircleSmall}>
                <FaIndustry />
              </div>

              <span>
                RAPIER LOOMS
              </span>

            </div>

          </div>

        </section>


        {/* ====================================================
            ABOUT + FABRIC RANGE
        ==================================================== */}

        <section
          className="ashraf-two-column"
          style={styles.twoColumnSection}
        >

          {/* ABOUT */}

          <div
            className="content-panel fade-up"
            style={styles.column}
          >

            <div className="section-kicker">
              OUR HERITAGE
            </div>

            <h2 style={styles.sectionHeader}>
              ABOUT THE DIVISION
            </h2>

            <div style={styles.goldOrnamentSmall}>
              ❖
            </div>

            <p style={styles.paragraph}>
              Ashraf Textile stands as the foundation of
              Ashraf Group of Industries, with its origins
              dating back to{' '}
              <strong style={styles.goldText}>
                1901
              </strong>.
            </p>

            <p style={styles.paragraph}>
              What began as a modest textile operation has
              evolved into a modern manufacturing unit,
              combining over a century of experience with
              advanced weaving technologies.
            </p>

            <p style={styles.paragraph}>
              Today, the division operates a sophisticated
              setup of Waterjet Looms and Rapier Looms,
              enabling the production of high-quality fabrics
              that meet both domestic and international
              standards.
            </p>

            <div
              className="stat-box-hover"
              style={styles.statBox}
            >

              <FaIndustry style={styles.statIcon} />

              <div>

                <h3 style={styles.statNumber}>
                  100+ YEARS
                </h3>

                <p style={styles.statLabel}>
                  OF WEAVING HERITAGE
                </p>

              </div>

            </div>

          </div>


          {/* DIVIDER */}

          <div
            className="ashraf-vertical-divider"
            style={styles.verticalDivider}
          />


          {/* SPECIALIZED RANGE */}

          <div
            className="content-panel fade-up delay-2"
            style={styles.column}
          >

            <div className="section-kicker">
              OUR CAPABILITIES
            </div>

            <h2 style={styles.sectionHeader}>
              SPECIALIZED FABRIC RANGE
            </h2>

            <div style={styles.goldOrnamentSmall}>
              ❖
            </div>

            <ul style={styles.featureList}>

              <li style={styles.featureItem}>

                <div
                  className="feature-icon-hover"
                  style={styles.goldIconCircle}
                >
                  <GiSewingNeedle />
                </div>

                <div style={styles.featureContent}>

                  <h4 style={styles.featureTitle}>
                    Premium Organza Fabrics
                  </h4>

                  <p style={styles.featureDesc}>
                    Delicate, sheer and luxurious fabrics
                    crafted for elegance.
                  </p>

                </div>

              </li>


              <li style={styles.featureItem}>

                <div
                  className="feature-icon-hover"
                  style={styles.goldIconCircle}
                >
                  <FaLayerGroup />
                </div>

                <div style={styles.featureContent}>

                  <h4 style={styles.featureTitle}>
                    Korean Raw Silk (Viscose)
                  </h4>

                  <p style={styles.featureDesc}>
                    Finest quality viscose yarns for a
                    smooth and rich finish.
                  </p>

                </div>

              </li>


              <li style={styles.featureItem}>

                <div
                  className="feature-icon-hover"
                  style={styles.goldIconCircle}
                >
                  <GiSpinningBlades />
                </div>

                <div style={styles.featureContent}>

                  <h4 style={styles.featureTitle}>
                    Lightweight & Luxury Dress Materials
                  </h4>

                  <p style={styles.featureDesc}>
                    Perfect for haute couture, formal wear
                    and premium collections.
                  </p>

                </div>

              </li>


              <li style={styles.featureItem}>

                <div
                  className="feature-icon-hover"
                  style={styles.goldIconCircle}
                >
                  <FaDraftingCompass />
                </div>

                <div style={styles.featureContent}>

                  <h4 style={styles.featureTitle}>
                    Custom Weaving Solutions
                  </h4>

                  <p style={styles.featureDesc}>
                    Tailored fabric development to meet
                    diverse customer requirements.
                  </p>

                </div>

              </li>

            </ul>

          </div>

        </section>


        {/* ====================================================
            ADVANCED INFRASTRUCTURE
        ==================================================== */}

        <section style={styles.infraSection}>

          <div
            className="ashraf-infra-header fade-up"
            style={styles.infraHeaderWrapper}
          >

            <div style={styles.lineDivider} />

            <div className="infra-title-wrapper">

              <span className="section-kicker">
                TECHNOLOGY
              </span>

              <h2 style={styles.infraHeader}>
                ADVANCED INFRASTRUCTURE
              </h2>

            </div>

            <div style={styles.lineDivider} />

          </div>


          <div
            className="ashraf-infrastructure"
            style={styles.infraGrid}
          >

            <div
              className="infra-card-hover"
              style={styles.infraCard}
            >

              <div style={styles.navyIconCircle}>
                <FaCog />
              </div>

              <h4 style={styles.infraTitle}>
                HIGH-SPEED WATERJET LOOMS
              </h4>

              <p style={styles.infraDesc}>
                State-of-the-art waterjet looms for
                high precision and superior fabric quality.
              </p>

            </div>


            <div
              className="infra-card-hover"
              style={styles.infraCard}
            >

              <div style={styles.navyIconCircle}>
                <FaIndustry />
              </div>

              <h4 style={styles.infraTitle}>
                PRECISION RAPIER LOOMS
              </h4>

              <p style={styles.infraDesc}>
                Advanced rapier technology ensures
                efficiency, versatility and consistent
                performance.
              </p>

            </div>


            <div
              className="infra-card-hover"
              style={styles.infraCard}
            >

              <div style={styles.navyIconCircle}>
                <FaCheckCircle />
              </div>

              <h4 style={styles.infraTitle}>
                CONSISTENT QUALITY CONTROL
              </h4>

              <p style={styles.infraDesc}>
                Rigorous quality checks at every stage
                to maintain international standards.
              </p>

            </div>


            <div
              className="infra-card-hover"
              style={styles.infraCard}
            >

              <div style={styles.navyIconCircle}>
                <FaChartLine />
              </div>

              <h4 style={styles.infraTitle}>
                SCALABLE PRODUCTION CAPACITY
              </h4>

              <p style={styles.infraDesc}>
                Efficient systems and skilled workforce
                to meet bulk orders with on-time delivery.
              </p>

            </div>

          </div>

        </section>


        {/* ====================================================
            CALLOUT
        ==================================================== */}

        <section
          className="ashraf-callout"
          style={styles.calloutBanner}
        >

          {/* DECORATIVE GOLD LINE */}

          <div className="callout-gold-line" />


          {/* THREAD IMAGE */}

          <div
            className="ashraf-thread-images"
            style={styles.threadImages}
          >

            <img
              src={threadWhite}
              alt="Textile thread"
              style={styles.threadImage}
            />

          </div>


          {/* TEXT */}

          <div
            className="ashraf-callout-text"
            style={styles.calloutText}
          >

            <span className="callout-small-title">
              A LEGACY WOVEN INTO EVERY THREAD
            </span>

            <h3
              className="ashraf-callout-title"
              style={styles.calloutTitle}
            >
              OVER A CENTURY OF WEAVING EXCELLENCE
            </h3>

            <p
              className="ashraf-callout-sub"
              style={styles.calloutSub}
            >
              ✦ INTO EVERY THREAD. ✦
            </p>

          </div>


          <div className="callout-gold-line right-line" />

        </section>


        {/* ====================================================
            FOOTER
        ==================================================== */}

        <footer
          className="ashraf-footer"
          style={styles.footer}
        >

          {/* FOOTER BRAND */}

          <div
            className="ashraf-footer-brand"
            style={styles.footerBrand}
          >

            <img
              src={logo}
              alt="Ashraf Textile"
              className="ashraf-footer-logo"
              style={styles.footerLogo}
            />

            <div
              className="ashraf-footer-brand-text"
              style={styles.footerBrandText}
            >

              <strong style={styles.footerTextTitle}>
                ASHRAF TEXTILE
              </strong>

              <span style={styles.footerSince}>
                — SINCE 1901 —
              </span>

            </div>

          </div>


          {/* COMPANY */}

          <div
            className="ashraf-footer-company"
            style={styles.footerCompany}
          >

            <span className="footer-company-kicker">
              A COMPANY OF
            </span>

            <strong style={styles.footerCompanyStrong}>
              ASHRAF GROUP OF INDUSTRIES
            </strong>

            <span style={styles.footerTagline}>
              Building Legacy. Powering the Future.
            </span>

          </div>


          {/* DIVIDER */}

          <div
            className="ashraf-footer-divider"
            style={styles.footerDivider}
          />


          {/* WEBSITE */}

          <div
            className="ashraf-footer-link"
            style={styles.footerLink}
          >

            <FaGlobe style={styles.websiteIcon} />

            <div className="footer-website-wrapper">

              <span className="footer-website-label">
                VISIT US
              </span>

              <a
                href="https://www.ashrafiafood.com"
                target="_blank"
                rel="noreferrer"
                style={styles.linkText}
              >
                www.ashrafiafood.com
              </a>

            </div>

          </div>

        </footer>

      </main>


      {/* ======================================================
          RESPONSIVE + ANIMATION CSS
      ====================================================== */}

      <style>
        {`

          * {
            box-sizing: border-box;
          }


          html {
            scroll-behavior: smooth;
          }


          html,
          body,
          #root {
            margin: 0;
            padding: 0;
            width: 100%;
            min-height: 100%;
          }


          body {
            overflow-x: hidden;
            background: #eef2f5;
          }


          /* ==================================================
             GLOBAL ANIMATION
          ================================================== */

          @keyframes fadeUp {

            from {
              opacity: 0;
              transform: translateY(25px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }

          }


          @keyframes fadeDown {

            from {
              opacity: 0;
              transform: translateY(-20px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }

          }


          @keyframes scaleIn {

            from {
              opacity: 0;
              transform: scale(0.94);
            }

            to {
              opacity: 1;
              transform: scale(1);
            }

          }


          @keyframes shimmer {

            0% {
              transform: translateX(-100%);
            }

            100% {
              transform: translateX(100%);
            }

          }


          @keyframes floating {

            0%,
            100% {
              transform: translateY(0);
            }

            50% {
              transform: translateY(-7px);
            }

          }


          @keyframes goldPulse {

            0%,
            100% {
              box-shadow:
                0 0 0 rgba(197,160,89,0);
            }

            50% {
              box-shadow:
                0 0 18px rgba(197,160,89,0.35);
            }

          }


          @keyframes rotateOrnament {

            0% {
              transform: rotate(0deg);
            }

            100% {
              transform: rotate(360deg);
            }

          }


          .ashraf-header {
            animation: fadeDown 0.8s ease both;
          }


          .ashraf-gallery-card {
            animation: scaleIn 0.7s ease both;
          }


          .ashraf-gallery-card:nth-child(1) {
            animation-delay: 0.15s;
          }


          .ashraf-gallery-card:nth-child(2) {
            animation-delay: 0.25s;
          }


          .ashraf-gallery-card:nth-child(3) {
            animation-delay: 0.35s;
          }


          .ashraf-gallery-card:nth-child(4) {
            animation-delay: 0.45s;
          }


          .fade-up {
            animation: fadeUp 0.8s ease both;
          }


          .delay-2 {
            animation-delay: 0.2s;
          }


          /* ==================================================
             BACK BUTTON
          ================================================== */

          .ashraf-back-button {
            position: relative;
            overflow: hidden;
          }


          .ashraf-back-button::before {
            content: "";
            position: absolute;
            top: 0;
            left: -120%;
            width: 80%;
            height: 100%;
            background:
              linear-gradient(
                90deg,
                transparent,
                rgba(255,255,255,0.18),
                transparent
              );
            transform: skewX(-20deg);
            transition: left 0.6s ease;
          }


          .ashraf-back-button:hover::before {
            left: 130%;
          }


          .ashraf-back-button:hover {
            transform: translateY(-2px);
            box-shadow:
              0 8px 20px rgba(11,37,69,0.2);
          }


          .ashraf-back-button:active {
            transform: translateY(0);
          }


          /* ==================================================
             LOGO
          ================================================== */

          .logo-glow {
            animation: floating 4s ease-in-out infinite;
          }


          .logo-glow img {
            transition:
              transform 0.5s ease,
              filter 0.5s ease;
          }


          .logo-glow:hover img {
            transform: scale(1.04);
            filter:
              drop-shadow(
                0 8px 15px rgba(11,37,69,0.15)
              );
          }


          .title-eyebrow {
            display: inline-block;
            font-family: Arial, sans-serif;
            font-size: 10px;
            font-weight: bold;
            letter-spacing: 3px;
            color: #c5a059;
            margin-bottom: 7px;
            animation: fadeUp 1s ease 0.25s both;
          }


          /* ==================================================
             ORNAMENT
          ================================================== */

          .ashraf-header-right > div:last-child {
            animation:
              rotateOrnament 12s linear infinite,
              goldPulse 3s ease-in-out infinite;
            display: inline-block;
          }


          /* ==================================================
             GALLERY
          ================================================== */

          .ashraf-gallery {
            overflow: hidden;
          }


          .ashraf-gallery-card {
            position: relative;
            overflow: hidden;
            transition:
              transform 0.4s ease,
              box-shadow 0.4s ease;
          }


          .ashraf-gallery-card:hover {
            z-index: 5;
            transform: translateY(-7px);
            box-shadow:
              0 18px 35px rgba(11,37,69,0.18);
          }


          .ashraf-image-area {
            position: relative;
            width: 100%;
            height: 250px;
            overflow: hidden;
            margin: 0;
            padding: 0;
          }


          .ashraf-gallery-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition:
              transform 0.8s cubic-bezier(.2,.7,.2,1),
              filter 0.5s ease;
          }


          .ashraf-gallery-card:hover
          .ashraf-gallery-image {
            transform: scale(1.09);
            filter: saturate(1.08);
          }


          .image-overlay {
            position: absolute;
            inset: 0;
            background:
              linear-gradient(
                135deg,
                rgba(11,37,69,0.08),
                transparent 55%,
                rgba(197,160,89,0.15)
              );
            pointer-events: none;
            transition: opacity 0.4s ease;
          }


          .ashraf-gallery-card:hover
          .image-overlay {
            opacity: 0.65;
          }


          .ashraf-image-area::after {
            content: "";
            position: absolute;
            top: 0;
            right: -1px;
            width: 1px;
            height: 100%;
            background:
              linear-gradient(
                to bottom,
                #c5a059,
                #ffffff,
                #c5a059
              );
            z-index: 3;
          }


          /* ==================================================
             DIAGONAL IMAGE SEPARATION
          ================================================== */

          .ashraf-gallery-card:nth-child(1)
          .ashraf-image-area {
            clip-path: polygon(
              0 0,
              100% 0,
              88% 100%,
              0 100%
            );
          }


          .ashraf-gallery-card:nth-child(2)
          .ashraf-image-area {
            clip-path: polygon(
              12% 0,
              100% 0,
              88% 100%,
              0 100%
            );

            margin-left: -1px;
            width: calc(100% + 1px);
          }


          .ashraf-gallery-card:nth-child(3)
          .ashraf-image-area {
            clip-path: polygon(
              12% 0,
              100% 0,
              88% 100%,
              0 100%
            );

            margin-left: -1px;
            width: calc(100% + 1px);
          }


          .ashraf-gallery-card:nth-child(4)
          .ashraf-image-area {
            clip-path: polygon(
              12% 0,
              100% 0,
              100% 100%,
              0 100%
            );

            margin-left: -1px;
            width: calc(100% + 1px);
          }


          /* ==================================================
             GALLERY LABELS
          ================================================== */

          .ashraf-gallery-label {
            position: relative;
            z-index: 10;
            transition:
              background-color 0.35s ease,
              padding 0.35s ease;
          }


          .ashraf-gallery-card:hover
          .ashraf-gallery-label {
            background-color: #12365f !important;
          }


          .iconCircleSmall {
            transition:
              transform 0.4s ease,
              box-shadow 0.4s ease;
          }


          .ashraf-gallery-card:hover
          .iconCircleSmall {
            transform: scale(1.1) rotate(-5deg);
            box-shadow:
              0 5px 15px rgba(197,160,89,0.35);
          }


          /* ==================================================
             CONTENT
          ================================================== */

          .content-panel {
            position: relative;
          }


          .section-kicker {
            font-family: Arial, sans-serif;
            color: #c5a059;
            font-size: 9px;
            font-weight: bold;
            letter-spacing: 2.5px;
            text-align: center;
            margin-bottom: 4px;
          }


          .paragraph {
            transition:
              transform 0.3s ease,
              color 0.3s ease;
          }


          .paragraph:hover {
            transform: translateX(3px);
            color: #333 !important;
          }


          /* ==================================================
             STAT BOX
          ================================================== */

          .stat-box-hover {
            transition:
              transform 0.35s ease,
              box-shadow 0.35s ease,
              border-color 0.35s ease;
          }


          .stat-box-hover:hover {
            transform: translateY(-4px);
            border-color: #c5a059 !important;
            box-shadow:
              0 10px 25px rgba(11,37,69,0.09);
          }


          .stat-box-hover svg {
            transition:
              transform 0.4s ease;
          }


          .stat-box-hover:hover svg {
            transform: rotate(-8deg) scale(1.08);
          }


          /* ==================================================
             FEATURE ICONS
          ================================================== */

          .feature-icon-hover {
            transition:
              transform 0.35s ease,
              box-shadow 0.35s ease;
          }


          .featureItem:hover .feature-icon-hover {
            transform: translateY(-3px) rotate(-5deg);
            box-shadow:
              0 7px 18px rgba(197,160,89,0.28);
          }


          .featureItem {
            transition:
              transform 0.3s ease;
          }


          .featureItem:hover {
            transform: translateX(4px);
          }


          /* ==================================================
             INFRASTRUCTURE
          ================================================== */

          .infra-card-hover {
            transition:
              transform 0.4s ease,
              box-shadow 0.4s ease,
              border-color 0.4s ease;
          }


          .infra-card-hover:hover {
            transform: translateY(-7px);
            border-color: #c5a059 !important;
            box-shadow:
              0 14px 30px rgba(11,37,69,0.12);
          }


          .infra-card-hover
          .navy-icon-circle {
            transition:
              transform 0.4s ease;
          }


          .infra-card-hover:hover
          .navy-icon-circle {
            transform: scale(1.08) rotate(5deg);
          }


          /* ==================================================
             CALLOUT
          ================================================== */

          .ashraf-callout {
            gap: 0 !important;
          }


          .ashraf-thread-images {
            justify-content: flex-end !important;
            margin-right: 8px !important;
          }


          .ashraf-thread-images img {
            transition:
              transform 0.5s ease,
              filter 0.5s ease;
            animation:
              floating 4s ease-in-out infinite;
          }


          .ashraf-thread-images:hover img {
            transform: scale(1.08) rotate(-2deg);
            filter:
              drop-shadow(
                0 5px 12px rgba(197,160,89,0.25)
              );
          }


          .ashraf-callout-text {
            margin-left: 0 !important;
          }


          .callout-small-title {
            display: block;
            color: rgba(255,255,255,0.65);
            font-family: Arial, sans-serif;
            font-size: 9px;
            font-weight: bold;
            letter-spacing: 3px;
            margin-bottom: 6px;
          }


          .callout-gold-line {
            width: 70px;
            height: 1px;
            background: #c5a059;
            flex-shrink: 0;
          }


          .callout-gold-line.right-line {
            margin-left: 15px;
          }


          /* ==================================================
             FOOTER
          ================================================== */

          .ashraf-footer {
            position: relative;
          }


          .ashraf-footer::before {
            content: "";
            position: absolute;
            top: 0;
            left: 5%;
            right: 5%;
            height: 2px;
            background:
              linear-gradient(
                90deg,
                transparent,
                #c5a059,
                transparent
              );
          }


          .ashraf-footer-brand {
            transition: transform 0.3s ease;
          }


          .ashraf-footer-brand:hover {
            transform: translateY(-3px);
          }


          .ashraf-footer-logo {
            transition:
              transform 0.4s ease;
          }


          .ashraf-footer-brand:hover
          .ashraf-footer-logo {
            transform: scale(1.05);
          }


          .footer-company-kicker {
            font-family: Arial, sans-serif;
            font-size: 8px;
            font-weight: bold;
            letter-spacing: 2.5px;
            color: #c5a059;
            margin-bottom: 5px;
          }


          .ashraf-footer-company {
            transition:
              transform 0.3s ease;
          }


          .ashraf-footer-company:hover {
            transform: translateY(-3px);
          }


          .footer-website-label {
            display: block;
            font-family: Arial, sans-serif;
            font-size: 8px;
            font-weight: bold;
            letter-spacing: 2px;
            color: #c5a059;
            margin-bottom: 3px;
          }


          .footer-website-wrapper {
            display: flex;
            flex-direction: column;
          }


          .footer-website-wrapper a {
            transition:
              color 0.25s ease,
              transform 0.25s ease;
          }


          .footer-website-wrapper a:hover {
            color: #c5a059 !important;
            transform: translateX(2px);
          }


          .websiteIcon {
            transition:
              transform 0.4s ease;
          }


          .ashraf-footer-link:hover .websiteIcon {
            transform: rotate(15deg) scale(1.1);
          }


          /* ==================================================
             TABLET
          ================================================== */

          @media (max-width: 1100px) {

            .ashraf-poster {
              padding-left: 4%;
              padding-right: 4%;
            }


            .ashraf-gallery {
              grid-template-columns: repeat(2, 1fr) !important;
            }


            .ashraf-infrastructure {
              grid-template-columns: repeat(2, 1fr) !important;
            }


            .ashraf-gallery-card {
              border-bottom:
                1px solid #c5a059 !important;
            }


            .ashraf-main-title {
              font-size: 34px !important;
            }


            .ashraf-image-area {
              height: 280px;
            }

          }


          /* ==================================================
             TABLET / SMALL
          ================================================== */

          @media (max-width: 850px) {

            .ashraf-header {
              gap: 18px !important;
            }


            .ashraf-header-left {
              width: 230px !important;
            }


            .ashraf-main-title {
              font-size: 29px !important;
              letter-spacing: 2px !important;
            }


            .ashraf-tagline {
              font-size: 14px !important;
            }


            .ashraf-two-column {
              gap: 25px !important;
            }


            .callout-gold-line {
              display: none;
            }


            .ashraf-thread-images {
              width: 230px !important;
            }

          }


          /* ==================================================
             MOBILE
          ================================================== */

          @media (max-width: 650px) {

            .ashraf-poster {
              padding:
                16px
                16px
                20px !important;
            }


            .ashraf-back-wrapper {
              padding: 0 !important;
              margin-bottom: 16px !important;
            }


            .ashraf-back-button {
              width: 100%;
              justify-content: center;
              padding: 12px 16px !important;
            }


            /* HEADER */

            .ashraf-header {
              flex-direction: column !important;
              gap: 15px !important;
              padding-bottom: 18px !important;
            }


            .ashraf-header-left {
              width: 100% !important;
            }


            .logo-glow img {
              width: 175px !important;
            }


            .ashraf-header-divider {
              width: 75% !important;
              height: 1px !important;
            }


            .ashraf-header-right {
              width: 100% !important;
              padding-left: 0 !important;
            }


            .title-eyebrow {
              font-size: 8px !important;
              letter-spacing: 2px !important;
            }


            .ashraf-main-title {
              font-size: 26px !important;
              letter-spacing: 1.5px !important;
              line-height: 1.2 !important;
            }


            .ashraf-tagline {
              font-size: 13px !important;
              line-height: 1.5 !important;
            }


            /* GALLERY */

            .ashraf-gallery {
              grid-template-columns: 1fr !important;
              margin-top: 18px !important;
            }


            .ashraf-gallery-card {
              border-right: none !important;
              border-bottom:
                1px solid #c5a059 !important;
            }


            .ashraf-image-area {
              height: 230px !important;
            }


            .ashraf-gallery-card:nth-child(1)
            .ashraf-image-area {
              clip-path: polygon(
                0 0,
                100% 0,
                92% 100%,
                0 100%
              );
            }


            .ashraf-gallery-card:nth-child(2)
            .ashraf-image-area,
            .ashraf-gallery-card:nth-child(3)
            .ashraf-image-area {
              clip-path: polygon(
                8% 0,
                100% 0,
                92% 100%,
                0 100%
              );
            }


            .ashraf-gallery-card:nth-child(4)
            .ashraf-image-area {
              clip-path: polygon(
                8% 0,
                100% 0,
                100% 100%,
                0 100%
              );
            }


            /* ABOUT */

            .ashraf-two-column {
              flex-direction: column !important;
              gap: 25px !important;
              margin-top: 25px !important;
            }


            .ashraf-vertical-divider {
              width: 100% !important;
              height: 1px !important;
            }


            .sectionHeader {
              font-size: 19px !important;
            }


            .paragraph {
              font-size: 13px !important;
              line-height: 1.65 !important;
            }


            /* INFRASTRUCTURE */

            .ashraf-infrastructure {
              grid-template-columns: 1fr !important;
              gap: 12px !important;
            }


            .ashraf-infra-header {
              gap: 8px !important;
            }


            .ashraf-infra-header > div {
              display: none;
            }


            .infra-title-wrapper {
              width: 100%;
            }


            .ashraf-infra-header
            .section-kicker {
              margin-bottom: 3px;
            }


            .ashraf-infra-header
            .infraHeader {
              font-size: 17px !important;
            }


            /* CALLOUT */

            .ashraf-callout {
              flex-direction: row !important;
              text-align: center !important;
              padding:
                16px 8px !important;
              gap: 0 !important;
              min-height: 110px !important;
            }


            .ashraf-thread-images {
              width: 78px !important;
              margin-right: 3px !important;
              flex-shrink: 0 !important;
              justify-content: flex-end !important;
            }


            .ashraf-thread-images img {
              width: 80px !important;
              max-height: 90px !important;
            }


            .ashraf-callout-text {
              padding-right: 0 !important;
              margin-left: 0 !important;
              flex: 1 !important;
            }


            .callout-small-title {
              font-size: 6.5px !important;
              letter-spacing: 1.4px !important;
              margin-bottom: 4px !important;
            }


            .ashraf-callout-title {
              font-size: 13px !important;
              line-height: 1.35 !important;
              letter-spacing: 0.5px !important;
            }


            .ashraf-callout-sub {
              font-size: 11px !important;
              margin-top: 5px !important;
              letter-spacing: 1px !important;
            }


            /* FOOTER */

            .ashraf-footer {
              flex-direction: column !important;
              gap: 18px !important;
              text-align: center !important;
              padding:
                28px 12px 16px !important;
            }


            .ashraf-footer-brand {
              justify-content: center !important;
            }


            .ashraf-footer-company {
              align-items: center !important;
              text-align: center !important;
            }


            .ashraf-footer-divider {
              width: 70px !important;
              height: 1px !important;
            }


            .ashraf-footer-link {
              justify-content: center !important;
            }


            .footer-company-kicker {
              font-size: 7px !important;
            }


            .ashraf-footer-company strong {
              font-size: 15px !important;
              letter-spacing: 0.5px;
            }


            .footer-website-wrapper {
              align-items: flex-start;
            }

          }


          /* ==================================================
             VERY SMALL MOBILE
          ================================================== */

          @media (max-width: 400px) {

            .ashraf-poster {
              padding-left: 12px !important;
              padding-right: 12px !important;
            }


            .ashraf-main-title {
              font-size: 23px !important;
            }


            .ashraf-image-area {
              height: 210px !important;
            }


            .ashraf-thread-images {
              width: 65px !important;
            }


            .ashraf-thread-images img {
              width: 68px !important;
            }


            .ashraf-callout-title {
              font-size: 11.5px !important;
            }


            .ashraf-callout-sub {
              font-size: 10px !important;
            }

          }


          /* ==================================================
             ACCESSIBILITY
          ================================================== */

          @media (prefers-reduced-motion: reduce) {

            *,
            *::before,
            *::after {
              animation-duration: 0.01ms !important;
              animation-iteration-count: 1 !important;
              transition-duration: 0.01ms !important;
              scroll-behavior: auto !important;
            }

          }

        `}
      </style>

    </div>
  );
}


// ============================================================
// STYLES
// ============================================================

const styles = {

  // ==========================================================
  // PAGE
  // ==========================================================

  pageBackground: {
    background:
      'linear-gradient(135deg, #eef2f5 0%, #f8f7f3 50%, #e9edf1 100%)',

    minHeight: '100vh',

    width: '100%',

    padding: 0,

    fontFamily:
      '"Georgia", "Times New Roman", serif',

    color: '#333'
  },


  // ==========================================================
  // POSTER
  // ==========================================================

  posterCard: {

    width: '100%',

    minHeight: '100vh',

    margin: 0,

    backgroundColor: '#fffdf9',

    border: 'none',

    boxShadow:
      '0 10px 40px rgba(0,0,0,0.07)',

    overflow: 'hidden',

    padding:
      '22px 5% 20px'
  },


  // ==========================================================
  // BACK BUTTON
  // ==========================================================

  backWrapper: {

    width: '100%',

    marginBottom: '20px'

  },


  backButton: {

    background:
      'linear-gradient(135deg, #0b2545, #12365f)',

    color: '#fff',

    border: '1px solid rgba(197,160,89,0.35)',

    padding: '11px 20px',

    borderRadius: '5px',

    cursor: 'pointer',

    display: 'flex',

    alignItems: 'center',

    fontWeight: 'bold',

    fontFamily: 'Arial, sans-serif',

    fontSize: '14px',

    transition:
      'all 0.3s ease',

    boxShadow:
      '0 5px 15px rgba(11,37,69,0.12)'
  },


  backIcon: {

    marginRight: '8px'

  },


  // ==========================================================
  // HEADER
  // ==========================================================

  header: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'space-between',

    paddingBottom: '22px',

    borderBottom:
      '1px solid #e5dfd5',

    marginBottom: '2px',

    gap: '25px'

  },


  headerLeft: {

    width: '280px',

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    justifyContent: 'center',

    flexShrink: 0

  },


  logoImage: {

    width: '210px',

    maxWidth: '100%',

    height: 'auto',

    objectFit: 'contain',

    display: 'block'

  },


  headerLogoText: {

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    marginTop: '5px',

    lineHeight: '1.2',

    color: '#0b2545'

  },


  headerDivider: {

    width: '1px',

    height: '125px',

    background:
      'linear-gradient(to bottom, transparent, #c5a059, transparent)',

    flexShrink: 0

  },


  headerRight: {

    textAlign: 'center',

    flexGrow: 1,

    paddingLeft: '20px'

  },


  mainTitle: {

    margin: 0,

    fontSize: '40px',

    color: '#0b2545',

    letterSpacing: '3px',

    fontWeight: '700'

  },


  mainSub: {

    margin: '5px 0 9px 0',

    fontSize: '12px',

    color: '#c5a059',

    fontWeight: 'bold',

    letterSpacing: '3px'

  },


  tagline: {

    margin: 0,

    fontStyle: 'italic',

    fontSize: '17px',

    color: '#555'

  },


  goldOrnament: {

    color: '#c5a059',

    fontSize: '15px',

    marginTop: '8px'

  },


  // ==========================================================
  // GALLERY
  // ==========================================================

  galleryGrid: {

    display: 'grid',

    gridTemplateColumns:
      'repeat(4, 1fr)',

    gap: 0,

    margin: '25px 0 8px 0',

    width: '100%'

  },


  galleryCard: {

    backgroundColor: '#0b2545',

    overflow: 'hidden',

    display: 'flex',

    flexDirection: 'column',

    minWidth: 0,

    position: 'relative',

    borderRight:
      '1px solid rgba(197,160,89,0.45)'

  },


  imageArea: {

    width: '100%',

    height: '250px',

    position: 'relative',

    overflow: 'hidden',

    margin: 0,

    padding: 0

  },


  galleryImg: {

    width: '100%',

    height: '100%',

    objectFit: 'cover',

    display: 'block'

  },


  // ==========================================================
  // GALLERY LABEL
  // ==========================================================

  galleryLabel: {

    background:
      'linear-gradient(135deg, #0b2545, #12365f)',

    padding: '9px 5px 11px',

    color: '#fff',

    fontSize: '11.5px',

    fontWeight: 'bold',

    textAlign: 'center',

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    gap: '5px',

    fontFamily: 'Georgia, serif',

    minHeight: '72px',

    justifyContent: 'center',

    position: 'relative',

    zIndex: 10

  },


  iconCircleSmall: {

    width: '35px',

    height: '35px',

    borderRadius: '50%',

    background:
      'linear-gradient(135deg, #c5a059, #dfbd77)',

    color: '#fff',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    fontSize: '15px',

    flexShrink: 0,

    transition: 'all 0.3s ease'

  },


  // ==========================================================
  // TWO COLUMN
  // ==========================================================

  twoColumnSection: {

    display: 'flex',

    gap: '42px',

    margin: '25px 0 32px',

    alignItems: 'stretch'

  },


  column: {

    flex: 1,

    minWidth: 0

  },


  verticalDivider: {

    width: '1px',

    background:
      'linear-gradient(to bottom, transparent, #c5a059, transparent)',

    opacity: 0.6,

    flexShrink: 0

  },


  sectionHeader: {

    fontSize: '21px',

    color: '#0b2545',

    textAlign: 'center',

    letterSpacing: '1px',

    margin: '0 0 4px 0'

  },


  goldOrnamentSmall: {

    textAlign: 'center',

    color: '#c5a059',

    fontSize: '12px',

    marginBottom: '15px'

  },


  goldText: {

    color: '#c5a059'

  },


  paragraph: {

    fontSize: '14px',

    lineHeight: '1.7',

    color: '#444',

    marginBottom: '14px'

  },


  // ==========================================================
  // STAT BOX
  // ==========================================================

  statBox: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    background:
      'linear-gradient(135deg, #fbf7f0, #fffdf9)',

    border:
      '1px solid #eadecc',

    padding: '16px',

    borderRadius: '7px',

    marginTop: '22px',

    transition: 'all 0.3s ease'

  },


  statIcon: {

    fontSize: '35px',

    color: '#c5a059',

    marginRight: '15px'

  },


  statNumber: {

    margin: 0,

    fontSize: '21px',

    color: '#0b2545',

    fontWeight: 'bold'

  },


  statLabel: {

    margin: 0,

    fontSize: '10px',

    color: '#777',

    letterSpacing: '1px',

    fontFamily: 'Arial, sans-serif'

  },


  // ==========================================================
  // FEATURES
  // ==========================================================

  featureList: {

    listStyle: 'none',

    padding: 0,

    margin: 0

  },


  featureItem: {

    display: 'flex',

    alignItems: 'flex-start',

    gap: '13px',

    marginBottom: '18px',

    cursor: 'default'

  },


  goldIconCircle: {

    width: '38px',

    height: '38px',

    borderRadius: '50%',

    background:
      'linear-gradient(135deg, #c5a059, #dfbd77)',

    color: '#fff',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    flexShrink: 0,

    marginTop: '2px',

    transition: 'all 0.3s ease'

  },


  featureContent: {

    flex: 1

  },


  featureTitle: {

    margin: 0,

    fontSize: '15px',

    color: '#0b2545',

    fontWeight: 'bold'

  },


  featureDesc: {

    margin: '3px 0 0 0',

    fontSize: '13px',

    color: '#666',

    lineHeight: '1.5'

  },


  // ==========================================================
  // INFRASTRUCTURE
  // ==========================================================

  infraSection: {

    margin: '30px 0 20px 0'

  },


  infraHeaderWrapper: {

    display: 'flex',

    alignItems: 'center',

    gap: '15px',

    marginBottom: '24px'

  },


  infraTitleWrapper: {

    textAlign: 'center'

  },


  lineDivider: {

    flex: 1,

    height: '1px',

    background:
      'linear-gradient(90deg, transparent, #c5a059)'

  },


  infraHeader: {

    margin: 0,

    fontSize: '19px',

    color: '#0b2545',

    letterSpacing: '1.5px',

    whiteSpace: 'nowrap'

  },


  infraGrid: {

    display: 'grid',

    gridTemplateColumns:
      'repeat(4, 1fr)',

    gap: '18px'

  },


  infraCard: {

    background:
      'linear-gradient(145deg, #fbf7f0, #fffdf9)',

    border:
      '1px solid #eadecc',

    borderRadius: '7px',

    padding: '20px 14px',

    textAlign: 'center',

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    transition: 'all 0.35s ease'

  },


  navyIconCircle: {

    width: '48px',

    height: '48px',

    borderRadius: '50%',

    background:
      'linear-gradient(135deg, #0b2545, #174673)',

    color: '#fff',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    fontSize: '19px',

    marginBottom: '12px',

    transition: 'all 0.35s ease'

  },


  infraTitle: {

    margin: '0 0 7px 0',

    fontSize: '12px',

    color: '#0b2545',

    fontWeight: 'bold',

    fontFamily: 'Arial, sans-serif'

  },


  infraDesc: {

    margin: 0,

    fontSize: '12px',

    color: '#555',

    lineHeight: '1.45'

  },


  // ==========================================================
  // CALLOUT
  // ==========================================================

  calloutBanner: {

    background:
      'linear-gradient(135deg, #081d36, #0b2545, #12365f)',

    color: '#c5a059',

    minHeight: '120px',

    display: 'flex',

    alignItems: 'center',

    gap: '0px',

    padding: '18px 28px',

    margin: '0',

    overflow: 'hidden',

    borderRadius: '3px',

    position: 'relative'

  },


  threadImages: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'flex-end',

    width: '300px',

    flexShrink: 0,

    marginRight: '8px'

  },


  threadImage: {

    width: '110px',

    height: 'auto',

    maxHeight: '110px',

    objectFit: 'contain',

    objectPosition: 'center',

    display: 'block'

  },


  calloutText: {

    flex: 1,

    textAlign: 'center',

    paddingRight: '10px',

    marginLeft: 0

  },


  calloutTitle: {

    margin: 0,

    color: '#c5a059',

    fontSize: '22px',

    letterSpacing: '1px',

    fontFamily: 'Georgia, serif'

  },


  calloutSub: {

    margin: '6px 0 0 0',

    color: '#fff',

    fontSize: '17px',

    letterSpacing: '2px',

    fontFamily: 'Georgia, serif'

  },


  // ==========================================================
  // FOOTER
  // ==========================================================

  footer: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'space-between',

    gap: '25px',

    padding: '28px 24px 18px',

    borderTop:
      '1px solid #e5dfd5',

    fontFamily: 'Arial, sans-serif',

    marginTop: 0,

    background:
      'linear-gradient(180deg, #faf8f4, #f4f0e8)'

  },


  footerBrand: {

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    gap: '6px',

    flexShrink: 0,

    minWidth: '145px',

    textAlign: 'center'

  },


  footerLogo: {

    width: '78px',

    height: 'auto',

    objectFit: 'contain',

    display: 'block'

  },


  footerBrandText: {

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    textAlign: 'center',

    lineHeight: '1.25'

  },


  footerTextTitle: {

    fontSize: '13px',

    color: '#0b2545',

    letterSpacing: '0.8px',

    fontFamily: 'Georgia, serif'

  },


  footerSince: {

    fontSize: '9px',

    color: '#c5a059',

    fontWeight: 'bold',

    letterSpacing: '1.5px',

    marginTop: '3px'

  },


  footerCompany: {

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    fontSize: '13px',

    color: '#0b2545',

    textAlign: 'center',

    flex: 1

  },


  footerCompanyStrong: {

    fontSize: '17px',

    fontWeight: 'bold',

    letterSpacing: '0.8px',

    color: '#0b2545'

  },


  footerTagline: {

    fontSize: '12px',

    color: '#c5a059',

    marginTop: '5px',

    fontStyle: 'italic'

  },


  footerDivider: {

    width: '1px',

    height: '55px',

    background:
      'linear-gradient(to bottom, transparent, #c5a059, transparent)',

    flexShrink: 0,

    opacity: 0.7

  },


  footerLink: {

    display: 'flex',

    alignItems: 'center',

    fontSize: '12px',

    color: '#0b2545',

    flexShrink: 0

  },


  websiteIcon: {

    marginRight: '9px',

    fontSize: '18px',

    color: '#c5a059'

  },


  linkText: {

    color: '#0b2545',

    textDecoration: 'none',

    fontWeight: 'bold',

    fontSize: '13px',

    transition:
      'color 0.25s ease'

  }

};